import { render } from "./InspectionConfirm.vue?vue&type=template&id=a28ccc7a"
import script from "./InspectionConfirm.vue?vue&type=script&lang=js"
export * from "./InspectionConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__